export var SET_CURRENT_ROUTE = 'SET_CURRENT_ROUTE';
export var SET_PREVIOUS_ROUTE = 'SET_PREVIOUS_ROUTE';